import React from 'react'
import style from './index.module.less'
import cls from 'classnames'

export default props => {
  // console.log(props)
  const { detailInfo = {} } = props
  return (
    <div className={cls(style.header, 'clearfix')}>
      <img
        className={style.img}
        src={
          detailInfo.coverImage
            ? detailInfo.coverImage + '?imageView2/1/w/150'
            : 'https://qnm.hunliji.com/Fp_2TWmeWLFd0e-ro1tjD7F8lGju'
        }
      />
      <div className={style.content}>
        <h3>
          <img src="https://qnm.hunliji.com/o_1di7ehqms1k5ji6v19c41j641p6qj.png" />
          <span>{detailInfo.title || ''}#</span>
        </h3>
        <p>{detailInfo.introduce}</p>
        <p>
          <span>{detailInfo.noteCount}讨论</span>
          <span style={{ margin: '0 6px' }}>|</span>
          <span>{detailInfo.watchCount}阅读</span>
        </p>
      </div>
    </div>
  )
}
